import gql from 'graphql-tag';

export default gql`
    query GetMobDetails($input: GetMobDetailsInput) {
        getMobDetails(input: $input) {
            stats {
                assetTypeId
                assetType
                plannedQty
                availableQty
                created
                readyForDispatch
                inRoute
                delivered
                actualQty
                additionalNeeded
            }
            jobInfo {
                mobStatus
                mobDate
                mobEndDate
                leapFrog
            }
        }
    }
`;
